module.exports = __webpack_public_path__ + "static/media/81VPz2vLzrL._AC_SL1500_.c0c42a08.jpg";